// #region IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { MdDriveFolderUpload } from 'react-icons/md';

import { useOfflineImport } from './useOfflineImport';
// CSS
import './OfflineImportButton.css';
// #endregion

// #region COMPONENT
/**
 * Trigger of the offline import: a label opening the folder picker of its
 * hidden input, confirms before replacing the local data, then runs the
 * import (progress shown in the app toast).
 * @param {object} props
 * @param {string} props.className Class giving the trigger its look
 * @param {function} [props.onImportStart] Called once the import is confirmed
 * @returns {JSX.Element} The label wrapping its hidden folder input
 */
export const OfflineImportButton = ({ className, onImportStart }) => {
  // #region INITIALIZATION
  const { t, handleFilesSelected } = useOfflineImport(onImportStart);

  const label = t('Buttons:Import data…');
  // #endregion

  // #region INTERFACE
  return (
    <label className={className}>
      <MdDriveFolderUpload className="OfflineImportButton-icon" />
      <span className="OfflineImportButton-label">{label}</span>
      <input
        type="file"
        webkitdirectory=""
        multiple
        hidden
        onChange={handleFilesSelected}
      />
    </label>
  );
  // #endregion
};

OfflineImportButton.propTypes = {
  className: PropTypes.string.isRequired,
  onImportStart: PropTypes.func,
};
// #endregion
